import * as PromotionModal from '../Promotion Modal/PromotionModal';
import * as bannerService from '/source/js/services/bannerService';

function showPromotionBannerModal() {
    let refId = $(this).attr('data-referenceId');
    PromotionModal.bindModal(refId);
}

function initalizeBanner() {
    let productsToCheck = [];
    let $slides = $('.page-level-promotion__ribbon');
    $slides.each(function (key, slide) {
        var sliderIdName = 'page__level__banner' + key;
        this.id = sliderIdName;
        var sliderId = '#' + sliderIdName;
        var alwaysDisplay = $(slide).attr('data-banner-alwaysdisplay');
        var isCheckStock = $(slide).attr('data-banner-checkstock');
        var productIds = $(slide).attr('data-banner-checkproduct');
        if(alwaysDisplay === 'false' && isCheckStock === 'true' && productIds) {
            productsToCheck = productIds.split(',');
            checkStock(sliderId, productsToCheck);
        }
    });
}

async function checkStock(sliderId, productsToCheck) {
    console.log('productsToCheck: ', productsToCheck);
    if(productsToCheck && productsToCheck.length > 0 && productsToCheck.some(i => i)) {
        let response = await bannerService.checkStock(productsToCheck);
        if(response && response.length > 0) {
            console.log('Response', response);
            if(response.length === productsToCheck.length) {
                $(sliderId).hide();
            }
        }
    }
}

$(function () {
    initalizeBanner();
    // $(this).scrollTop(0);
    $('.page-level-promotion__modal-link').on('click', showPromotionBannerModal);
});
